export const FAST_WITHDRAWAL_ESTIMATE_TIME = '~60 minutes'
export const STANDARD_WITHDRAWAL_ESTIMATE_TIME = '~24 hours'
